'use strict';

/**
 * Add active class when tab is clicked
 */
$(document).ready(function () {
    // Add active class when tab is clicked
    $('.nav-item').click(function () {
        $('.nav-item').removeClass('active');
        $(this).addClass('active');
    });

    $('.contact-us-landing-page').on('click', 'a[chat-tab]', function (eve) {
        var selectEle = eve.currentTarget.getAttribute('chat-tab');
        $('#' + selectEle + '-tab').click();
    });
});
